export default "__VITE_ASSET__ByiB6DFM__"